import { Button } from "$components/button/button";
import {
  useConvertFromPenceFactory,
  useConvertFromPoundsFactory,
} from "$routes/_lib/use-convert-currency";
import { IconButton, makeStyles, TextField } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { TRANSACTIONS } from "./formConstants";

const useStyles = makeStyles((theme) => ({
  buttonPadding: { padding: theme.spacing(1) },
  waivingWrapper: { display: "flex" },
  deleteIcon: {
    color: theme.palette.error.main,
    width: "47px",
  },
}));

type FormProps = {
  transactions?: { amountInPence: number }[];
};

export const Waive = ({ currency, totalPayableInPence }) => {
  const [waiving, setWaiving] = useState(false);
  const [waiveIndex, setWaiveIndex] = useState<number>(null);
  const { getValues, setValue, control } = useFormContext();
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const poundsToPence = useConvertFromPoundsFactory();
  const penceToPounds = useConvertFromPenceFactory();
  const { fields: transactions, ...arrayHelpers } = useFieldArray({
    name: TRANSACTIONS,
    control,
  });

  const waiveAmountLabel = formatMessage({
    id: "invoicing.waive.amount.label",
    defaultMessage: "Waive Amount",
  });

  if (!waiving) {
    return (
      <Button
        color="secondary"
        onClick={() => {
          setWaiving(true);
          setWaiveIndex(getValues()?.transactions.length);
          arrayHelpers.append({
            amountInPence: 0,
            authCode: "",
            currency,
            method: "WAIVER",
            type: "WAIVER",
          });
        }}
        data-testid="invoicing.takePayment.waiveButton"
      >
        <FormattedMessage
          id="invoicing.takePayment.waive"
          defaultMessage="Waive"
        />
      </Button>
    );
  }

  return (
    <div className={classes.waivingWrapper}>
      <TextField
        type="number"
        inputMode="numeric"
        data-testid="invoicing.takePayment.waiveAmount"
        label={waiveAmountLabel}
        name={`transactions.${waiveIndex}`}
        onChange={(e) => {
          const value = e.target.value || 0;
          setValue(
            `transactions.${waiveIndex}.amountInPence`,
            poundsToPence(value),
            { shouldValidate: true },
          );
          setValue(`transactions.${waiveIndex}.amount`, Number(value), {
            shouldValidate: true,
          });

          // it's always the first transaction that should be updated
          setValue(
            "transactions.0.amountInPence",
            totalPayableInPence - poundsToPence(value),
            { shouldValidate: true },
          );
          setValue(
            "transactions.0.amount",
            penceToPounds(totalPayableInPence) - Number(value),
            { shouldValidate: true },
          );
        }}
        InputProps={{
          inputProps: { min: 0, step: 1 },
        }}
      />
      <IconButton
        onClick={() => {
          setWaiving(false);
          arrayHelpers.remove(waiveIndex);
          setWaiveIndex(null);
        }}
        className={classes.buttonPadding}
      >
        <DeleteIcon className={classes.deleteIcon} />
      </IconButton>
    </div>
  );
};
